import React from 'react';
import ProductCard from './ProductCard';
import { theme } from '../utils/constants';

export default function FeaturedSection({
  title,
  products,
  addToCart,
  navigateTo,
  bg
}) {
  return (
    <>
      <section
        style={{
          padding: 'clamp(3.5rem, 8vw, 6rem) 20px',
          background: bg,
        }}
      >
        <div
          style={{
            maxWidth: '1450px',
            margin: '0 auto',
          }}
        >
          {/* Heading */}
          <div
            style={{
              textAlign: 'center',
              marginBottom: '4rem',
              maxWidth: '760px',
              marginInline: 'auto',
            }}
          >
            <h2
              className="featured-title"
              style={{
                fontFamily: "'Roboto Slab', serif",
                color: theme.text,
                margin: 0,
                position: 'relative',
                display: 'inline-block',
              }}
            >
              {title}

              <span
                style={{
                  position: 'absolute',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  bottom: '-16px',
                  width: '90px',
                  height: '4px',
                  borderRadius: '999px',
                  background: theme.accent,
                }}
              />
            </h2>

            <p
              style={{
                marginTop: '2rem',
                color: theme.textLight,
                lineHeight: 1.8,
                fontSize: '1.05rem',
              }}
            >
              Carefully selected products designed to inspire learning,
              creativity and personal growth.
            </p>
          </div>

          {/* Products */}
          <div className="featured-grid">
            {products.map((product) => (
              <ProductCard
                key={product.id}
                product={product}
                addToCart={addToCart}
                navigateTo={navigateTo}
              />
            ))}
          </div>

          {/* CTA */}
          <div
            style={{
              textAlign: 'center',
              marginTop: '4.5rem',
            }}
          >
            <button
              onClick={() =>
                navigateTo(
                  title.includes('Books')
                    ? 'books'
                    : 'accessories'
                )
              }
              className="featured-btn"
            >
              View All Products →
            </button>
          </div>
        </div>
      </section>

      <style jsx>{`
        .featured-title {
          font-size: clamp(2rem, 5vw, 3rem);
          line-height: 1.2;
          font-weight: 700;
        }

        .featured-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(310px, 1fr));
          gap: 2rem;
          align-items: stretch;
        }

        .featured-btn {
          padding: 1rem 2.8rem;
          border-radius: 999px;
          border: 2px solid ${theme.primary};
          background: white;
          color: ${theme.primary};
          font-size: 1rem;
          font-weight: 700;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .featured-btn:hover {
          background: ${theme.primary};
          color: white;
          transform: translateY(-3px);
          box-shadow: ${theme.shadowMd};
        }

        @media (max-width: 992px) {
          .featured-grid {
            grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
            gap: 1.8rem;
          }
        }

        @media (max-width: 768px) {
          .featured-grid {
            grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
            gap: 1.5rem;
          }
        }

        @media (max-width: 540px) {
          .featured-grid {
            grid-template-columns: 1fr;
          }

          .featured-btn {
            width: 100%;
            max-width: 340px;
          }
        }
      `}</style>
    </>
  );
}

// import React from 'react';
// import ProductCard from './ProductCard';
// import { theme } from '../utils/constants';

// export default function FeaturedSection({
//   title,
//   products,
//   addToCart,
//   navigateTo,
//   bg
// }) {
//   return (
//     <section
//       style={{
//         padding: '6rem 24px',
//         background: bg
//       }}
//     >
//       <div
//         style={{
//           maxWidth: '1400px',
//           margin: '0 auto'
//         }}
//       >
//         <h2
//           style={{
//             textAlign: 'center',
//             fontSize: '2.6rem',
//             marginBottom: '3.5rem',
//             fontFamily: "'Roboto Slab', serif",
//             position: 'relative',
//             color: theme.text
//           }}
//         >
//           {title}

//           <span
//             style={{
//               position: 'absolute',
//               bottom: '-12px',
//               left: '50%',
//               transform: 'translateX(-50%)',
//               width: '90px',
//               height: '4px',
//               background: theme.accent,
//               borderRadius: '2px'
//             }}
//           />
//         </h2>

//         <div
//           style={{
//             display: 'grid',
//             gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))',
//             gap: '2.5rem',
//             alignItems: 'stretch'
//           }}
//         >
//           {products.map((product) => (
//             <ProductCard
//               key={product.id}
//               product={product}
//               addToCart={addToCart}
//               navigateTo={navigateTo}
//             />
//           ))}
//         </div>

//         <div
//           style={{
//             textAlign: 'center',
//             marginTop: '4rem'
//           }}
//         >
//           <button
//             onClick={() =>
//               navigateTo(
//                 title.includes('Books') ? 'books' : 'accessories'
//               )
//             }
//             style={{
//               background: '#fff',
//               border: `2px solid ${theme.primary}`,
//               color: theme.primary,
//               padding: '1rem 2.5rem',
//               fontSize: '1.05rem',
//               fontWeight: 600,
//               borderRadius: '999px',
//               cursor: 'pointer',
//               transition: 'all .25s ease'
//             }}
//             onMouseEnter={(e) => {
//               e.currentTarget.style.background = theme.primary;
//               e.currentTarget.style.color = '#fff';
//             }}
//             onMouseLeave={(e) => {
//               e.currentTarget.style.background = '#fff';
//               e.currentTarget.style.color = theme.primary;
//             }}
//           >
//             View Products
//           </button>
//         </div>
//       </div>
//     </section>
//   );
// }
// // src/components/FeaturedSection.jsx
// import React from 'react';
// import ProductCard from './ProductCard'; // we'll extract this one next

// import { theme } from '../utils/constants';

// export default function FeaturedSection({ title, products, addToCart, navigateTo, bg }) {
//   return (
//     <section style={{ padding: '6rem 24px', background: bg }}>
//       <div style={{ maxWidth: '1280px', margin: '0 auto' }}>
//         <h2
//           style={{
//             textAlign: 'center',
//             fontSize: '2.6rem',
//             marginBottom: '3.5rem',
//             fontFamily: "'Roboto Slab', serif",
//             position: 'relative',
//             color: theme.text
//           }}
//         >
//           {title}
//           <span
//             style={{
//               position: 'absolute',
//               bottom: '-12px',
//               left: '50%',
//               transform: 'translateX(-50%)',
//               width: '90px',
//               height: '4px',
//               background: theme.accent,
//               borderRadius: '2px'
//             }}
//           />
//         </h2>

//         <div
//           style={{
//             display: 'grid',
//             gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
//             gap: '2rem'
//           }}
//         >
//           {products.map((product) => (
//             <ProductCard
//               key={product.id}
//               product={product}
//               addToCart={addToCart}
//               navigateTo={navigateTo}
//             />
//           ))}
//         </div>

//         <div style={{ textAlign: 'center', marginTop: '3.5rem' }}>
//           <button
//             onClick={() => navigateTo(title.includes('Books') ? 'books' : 'accessories')}
//             style={{
//               background: 'transparent',
//               border: `2px solid ${theme.primary}`,
//               color: theme.primary,
//               padding: '0.9rem 2.2rem',
//               fontSize: '1.05rem',
//               fontWeight: 500,
//               borderRadius: '50px',
//               cursor: 'pointer',
//               transition: 'all 0.25s'
//             }}
//           >
//             {/* View All {title.includes('Books') ? 'Books' : 'Accessories'} */}
//             View products
//           </button>
//         </div>
//       </div>
//     </section>
//   );
// }